export const ApiConfig = {
  endpoint: process.env.REACT_APP_API_GATEWAY_ENDPOINT,
};

export const OidcConfig = {
  authority: process.env.REACT_APP_COGNITO_USERPOOL_ENDPOINT,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_CALLBACK_URL,
  
};

export const SupportedChannel = [
  "Display",
  "Video",
  "Audio",
  "TV",
  "NativeDisplay",
  "NativeVideo",
  "OutOfHome",
];
